import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

import { API_URL, DATA_URL } from "@/common/config";

const ApiService = {
	init() {
		Vue.use(VueAxios, axios);
		Vue.axios.defaults.baseURL = API_URL;
	},

	setHeader() {
		Vue.axios.defaults.headers.common[
			"Authorization"
		] = `Token ${JwtService.getToken()}`;
	},

	query(resource, params) {
		return Vue.axios.get(resource, params).catch(error => {
			throw new Error(`[hellers24] ApiService ${error}`);
		});
	},

	get(resource, slug = "") {
		return Vue.axios.get(`${resource}/${slug}`).catch(error => {
			throw new Error(`[hellers24] ApiService ${error}`);
		});
	},

	post(resource, params) {
		return Vue.axios.post(`${resource}`, params);
	},

	update(resource, slug, params) {
		return Vue.axios.put(`${resource}/${slug}`, params);
	},

	put(resource, params) {
		return Vue.axios.put(`${resource}`, params);
	},

	delete(resource) {
		return Vue.axios.delete(resource).catch(error => {
			throw new Error(`[hellers24] ApiService ${error}`);
		});
	},

	loadData() {
		return new Promise((resolve, reject) => {
			this.query( API_URL + 'test' ).then(({ data }) => {

				data = this.parseResultData( data );
				if (data === false) {
					throw new Error(`[hellers24] ApiService loadData() – invalid data.`);
					reject();
				}

				resolve(data);
			});
		});
	},

	parseResultData( data ) {

		// Einfacher String statt JSON? ({a:1} statt {"a":"1"})
		// data = this.parseJsonString( data );

		// Valide?
		if (typeof data != 'object') return false;

		return data;
	},

	parseJsonString( data ) {
		if (typeof data == 'string') {
			eval(`data = ${data}`);
		}
		return data;
	}

};

export default ApiService;
